module.exports = __webpack_public_path__ + "img/icon_2@2x.32afa8a8.png";